import * as FormsActions from './actions/forms.actions';
//Valor por defecto
var defaultState = {
    form: '0',
    title: ''
};
//Crear nuevo objeto de estado
var newState = function (state, newData) {
    return Object.assign({}, state, newData);
};
var ɵ0 = newState;
export function formReducer(state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case FormsActions.UPDATE_FORM:
            return newState(state, { form: action.payload, title: action.title });
        default:
            return state;
    }
}
export { ɵ0 };
